import { render, staticRenderFns } from "./Verdict.vue?vue&type=template&id=35c40349&scoped=true"
import script from "./Verdict.vue?vue&type=script&lang=js"
export * from "./Verdict.vue?vue&type=script&lang=js"
import style0 from "./Verdict.vue?vue&type=style&index=0&id=35c40349&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c40349",
  null
  
)

export default component.exports